/**
 * 交通費の支給ルール(P-38。2026-09-15 発注者確定 → 2026-09-16 実装)。
 *
 *  - 対象は **品川のみ**(在宅・タイミー(単発)・管理は対象外)
 *  - その日の **実稼働時間**(拘束 − 休憩。同じ人が品川のBB IDを複数持つ日は合算)で決まる
 *      6時間未満        … 0円
 *      6時間以上8時間未満 … マスタ交通費 × 30%
 *      8時間以上        … マスタ交通費 × 50%
 *  - **その月の実稼働(品川)が 100時間以上なら、その月に稼働した全日を 70%** で支給し直す
 *    → 月の途中は 30%/50% で表示し、100時間を超えた時点で月全体を計算し直す
 *  - 金額は円未満を四捨五入(例: 460円 × 30% = 138円。現行シートの小原さん 9/1 と一致)
 *
 * マスタ交通費(往復)は `commuteOn(operator, date)`。改訂履歴を使うのでここには渡されたものだけを使う。
 */

/** 月の実稼働がこの時間以上なら、その月は全日 70% */
export const COMMUTE_MONTHLY_THRESHOLD_HOURS = 100;

/** その日の支給率(0 / 0.3 / 0.5 / 0.7) */
export function commuteRate(dayHours: number, monthHours: number): number {
  if (!(dayHours > 0)) return 0;
  if (monthHours >= COMMUTE_MONTHLY_THRESHOLD_HOURS) return 0.7;
  if (dayHours >= 8) return 0.5;
  if (dayHours >= 6) return 0.3;
  return 0;
}

/**
 * その日の交通費。
 * @param base      オペレーターマスタの往復交通費(その日の単価)
 * @param dayHours  その日の実稼働時間(品川のBB IDの合計)
 * @param monthHours その月の実稼働時間(品川。月途中は判明している分だけ)
 */
export function commuteAmount(base: number, dayHours: number, monthHours: number): number {
  if (!(base > 0)) return 0;
  return Math.round(base * commuteRate(dayHours, monthHours));
}
